import React from 'react';

const Dots = () => {
    return (
        <div className='header__dots'>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>          <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>          <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            <div className="header__dots_dot"></div>
            </div>
    );
};

export default Dots;